import { render } from "./JoinChannel.vue?vue&type=template&id=add39df4&ts=true"
import script from "./JoinChannel.vue?vue&type=script&lang=ts"
export * from "./JoinChannel.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/JoinChannel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "add39df4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('add39df4', __exports__)) {
    api.reload('add39df4', __exports__)
  }
  
  module.hot.accept("./JoinChannel.vue?vue&type=template&id=add39df4&ts=true", () => {
    api.rerender('add39df4', render)
  })

}


export default __exports__